import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledDateRangeMonthRadioGroup, StyledDateRangeMonthRadioItem} from './style'
import {YearQuarterEnum} from '@/types'
import {useTranslation} from '@/translations/i18n'

interface DateRangeQuarterSelectorProps {
    selectedQuarter: YearQuarterEnum
    onQuarterChange: (quarter: YearQuarterEnum) => void
    disabledOptions?: YearQuarterEnum[]
}

const quarters = [
    {
        labelKey: 'dashboard:quarter_1',
        value: 'jan_mar'
    },
    {
        labelKey: 'dashboard:quarter_2',
        value: 'apr_jun'
    },
    {
        labelKey: 'dashboard:quarter_3',
        value: 'jul_sep'
    },
    {
        labelKey: 'dashboard:quarter_4',
        value: 'oct_dec'
    }
] as const satisfies {labelKey: string; value: YearQuarterEnum}[]

export const DateRangeQuarterSelector = ({
    selectedQuarter,
    onQuarterChange,
    disabledOptions
}: DateRangeQuarterSelectorProps) => {
    const {t} = useTranslation()

    const handleQuarterSelect = (value: string) => {
        if (value) {
            onQuarterChange(value as YearQuarterEnum)
        }
    }

    return (
        <StyledDateRangeMonthRadioGroup type="single" value={selectedQuarter} onValueChange={handleQuarterSelect}>
            <Flexbox direction="column" gap={3} fullWidth align="stretch">
                {quarters.map(quarter => {
                    const isDisabled = !!disabledOptions?.includes(quarter.value)
                    return (
                        <StyledDateRangeMonthRadioItem
                            key={quarter.value}
                            value={quarter.value}
                            $isSelected={selectedQuarter === quarter.value}
                            $isDisabled={isDisabled}
                            disabled={isDisabled}
                        >
                            {t(quarter.labelKey)}
                        </StyledDateRangeMonthRadioItem>
                    )
                })}
            </Flexbox>
        </StyledDateRangeMonthRadioGroup>
    )
}
